(function() {
  var QUESTIONS = [
    {
      text: 'Where do you live?',
      note: '',
      options: [
        { score: 1, label: 'Studio or 1-bed flat, no outdoor space' },
        { score: 2, label: 'Flat with balcony, or apartment near a park' },
        { score: 3, label: 'House with small garden or shared courtyard' },
        { score: 4, label: 'House with medium or large private garden' },
        { score: 5, label: 'Rural property — land, fields, or open countryside nearby' }
      ]
    },
    {
      text: 'How physically active are you on a typical day?',
      note: '',
      options: [
        { score: 1, label: 'Mostly sedentary — desk job, exercise is rare' },
        { score: 2, label: 'Light activity — daily errands, occasional walks' },
        { score: 3, label: 'Moderately active — 30–45 min walking or exercise daily' },
        { score: 4, label: 'Active — daily exercise, walking, cycling, or outdoor activities' },
        { score: 5, label: 'Very active — running, hiking, cycling, or sport every day' }
      ]
    },
    {
      text: 'How many hours per day is your home left empty?',
      note: 'More time at home = higher score',
      options: [
        { score: 5, label: 'Never — someone is always home' },
        { score: 4, label: '1–3 hours — home is rarely empty' },
        { score: 3, label: '4–6 hours — half-day absences are common' },
        { score: 2, label: '6–8 hours — typical full working day away' },
        { score: 1, label: 'More than 8 hours — long days or frequent travel' }
      ]
    },
    {
      text: 'What is your honest monthly budget for a dog?',
      note: 'Include food, vet, grooming, insurance, toys, unexpected costs',
      options: [
        { score: 1, label: 'Under $80 / month' },
        { score: 2, label: '$80–$150 / month' },
        { score: 3, label: '$150–$250 / month' },
        { score: 4, label: '$250–$400 / month' },
        { score: 5, label: '$400+ / month — cost is not a primary concern' }
      ]
    },
    {
      text: 'Do you have children at home?',
      note: '',
      options: [
        { score: 1, label: 'Yes — children under 3' },
        { score: 2, label: 'Yes — children aged 3–6' },
        { score: 3, label: 'Yes — children aged 6–12' },
        { score: 4, label: 'Yes — teenagers (13 and over)' },
        { score: 5, label: 'No children at home' }
      ]
    },
    {
      text: 'Do you have other pets?',
      note: '',
      options: [
        { score: 1, label: 'Yes — cats that must coexist closely with the dog' },
        { score: 2, label: 'Yes — another dog already in the home' },
        { score: 3, label: 'Yes — small animals (rabbits, birds, rodents)' },
        { score: 4, label: 'Yes — other pets with minimal daily contact expected' },
        { score: 5, label: 'No other pets' }
      ]
    },
    {
      text: 'Does anyone in your household have dog allergies?',
      note: '',
      options: [
        { score: 1, label: 'Yes — confirmed allergy, hypoallergenic breed essential' },
        { score: 2, label: 'Yes — moderate, low-shedding strongly preferred' },
        { score: 3, label: 'Mild sensitivity — low-shedding preferred' },
        { score: 4, label: 'No, but low-shedding would be welcome' },
        { score: 5, label: 'No allergies at all' }
      ]
    },
    {
      text: 'How would you describe your grooming tolerance?',
      note: '',
      options: [
        { score: 1, label: 'Minimal — brushing once a week at most' },
        { score: 2, label: 'Basic — weekly brushing, occasional professional grooming' },
        { score: 3, label: 'Moderate — regular brushing, grooming every 6–8 weeks' },
        { score: 4, label: 'High — I enjoy grooming as a bonding activity' },
        { score: 5, label: 'Very high — intensive grooming is not a problem at all' }
      ]
    },
    {
      text: 'What is your experience with dogs?',
      note: '',
      options: [
        { score: 1, label: 'None — never owned a dog as an adult' },
        { score: 2, label: 'Limited — grew up around dogs but no adult ownership' },
        { score: 3, label: 'Some — owned one dog before, with mixed results' },
        { score: 4, label: 'Experienced — confident about training and management' },
        { score: 5, label: 'Expert — professional background or multiple dogs owned' }
      ]
    },
    {
      text: 'How would you describe your home environment?',
      note: '',
      options: [
        { score: 1, label: 'Small, busy, noisy — lots of people and unpredictability' },
        { score: 2, label: 'Compact but calm — limited space, quiet atmosphere' },
        { score: 3, label: 'Average — moderate space, normal household activity' },
        { score: 4, label: 'Spacious and calm — plenty of room, low activity levels' },
        { score: 5, label: 'Spacious and lively — large home, active household' }
      ]
    }
  ];

  var PROFILES = [
    {
      key: 'considered-companion',
      min: 10, max: 20,
      emoji: '🏠',
      title: 'The Considered Companion',
      tagline: 'Calm, adaptable, close-quarters living',
      desc: 'Your lifestyle is best suited to a calm, adaptable, lower-energy breed. You\'ll thrive with a dog that doesn\'t demand three hours of daily exercise, manages apartment living comfortably, and bonds deeply with one or two people rather than needing constant stimulation.',
      insight: 'This isn\'t about a boring dog — it\'s about a dog that fits your real life rather than fighting against it.',
      goodBreeds: ['Cavalier King Charles Spaniel', 'Bichon Frisé', 'Shih Tzu', 'Maltese', 'Basset Hound', 'Greyhound'],
      careBreeds: ['Border Collie', 'Siberian Husky', 'Vizsla', 'Australian Shepherd']
    },
    {
      key: 'balanced-owner',
      min: 21, max: 32,
      emoji: '⚖️',
      title: 'The Balanced Owner',
      tagline: 'Wide range available — match on temperament',
      desc: 'You have the space, time, and capacity for a wide range of breeds. Your main considerations are matching energy level, grooming tolerance, and whether you have children or other pets. You are in the most flexible position of any profile.',
      insight: 'Your decision should be driven by lifestyle fit and genuine temperament compatibility — not appearance alone.',
      goodBreeds: ['Labrador Retriever', 'Golden Retriever', 'English Cocker Spaniel', 'Whippet', 'Lagotto Romagnolo', 'Standard Poodle'],
      careBreeds: ['Czechoslovakian Wolfdog', 'Caucasian Shepherd', 'Dogue de Bordeaux']
    },
    {
      key: 'active-partner',
      min: 33, max: 50,
      emoji: '🏃',
      title: 'The Active Partner',
      tagline: 'High-drive breeds are within reach — but read carefully',
      desc: 'You have the resources, space, energy, and experience for almost any breed — including the most demanding ones. Your risk isn\'t under-committing; it\'s over-reaching. High-drive working breeds are genuinely fulfilling when the match is right, but punishing when managed by someone not truly ready.',
      insight: 'Use the breed profiles honestly. Pay close attention to trainability and independence ratings — even for experienced owners.',
      goodBreeds: ['Border Collie', 'Vizsla', 'Weimaraner', 'Dobermann', 'German Shepherd', 'Rhodesian Ridgeback'],
      careBreeds: ['Alaskan Malamute (hot climate)', 'Neapolitan Mastiff', 'Caucasian Shepherd']
    }
  ];

  var currentQ = 0;
  var answers = new Array(QUESTIONS.length).fill(null);

  // Elements
  var screenIntro     = document.getElementById('fk-screen-intro');
  var screenQuestions = document.getElementById('fk-screen-questions');
  var screenResult    = document.getElementById('fk-screen-result');

  function showScreen(el) {
    [screenIntro, screenQuestions, screenResult].forEach(function(s) {
      s.hidden = true;
      s.classList.remove('fk-quiz__screen--active');
    });
    el.hidden = false;
    el.classList.add('fk-quiz__screen--active');
    window.scrollTo({ top: document.getElementById('fk-quiz').offsetTop - 20, behavior: 'smooth' });
  }

  // Start
  document.getElementById('js-quiz-start').addEventListener('click', function() {
    currentQ = 0;
    renderQuestion();
    showScreen(screenQuestions);
  });

  function renderQuestion() {
    var q = QUESTIONS[currentQ];
    var pct = Math.round((currentQ / QUESTIONS.length) * 100);

    document.getElementById('js-progress-fill').style.setProperty('width', pct + '%', 'important');
    document.getElementById('js-progress-label').textContent = 'Question ' + (currentQ + 1) + ' of ' + QUESTIONS.length;
    document.getElementById('js-q-title').textContent = q.text;
    var noteEl = document.getElementById('js-q-note');
    noteEl.textContent = q.note || '';
    noteEl.style.display = q.note ? 'block' : 'none';

    var optionsEl = document.getElementById('js-options');
    optionsEl.innerHTML = '';
    q.options.forEach(function(opt, idx) {
      var li = document.createElement('li');
      li.className = 'fk-quiz__option' + (answers[currentQ] === opt.score ? ' fk-quiz__option--selected' : '');
      li.setAttribute('role', 'radio');
      li.setAttribute('aria-checked', answers[currentQ] === opt.score ? 'true' : 'false');
      li.innerHTML = '<span class="fk-quiz__option-radio"></span><span>' + escHtml(opt.label) + '</span>';
      li.addEventListener('click', function() {
        answers[currentQ] = opt.score;
        optionsEl.querySelectorAll('.fk-quiz__option').forEach(function(o) {
          o.classList.remove('fk-quiz__option--selected');
          o.setAttribute('aria-checked', 'false');
        });
        li.classList.add('fk-quiz__option--selected');
        li.setAttribute('aria-checked', 'true');
        document.getElementById('js-btn-next').disabled = false;
      });
      optionsEl.appendChild(li);
    });

    document.getElementById('js-btn-next').disabled = answers[currentQ] === null;
    document.getElementById('js-btn-back').style.visibility = currentQ === 0 ? 'hidden' : 'visible';
  }

  document.getElementById('js-btn-next').addEventListener('click', function() {
    if (answers[currentQ] === null) return;
    if (currentQ < QUESTIONS.length - 1) {
      currentQ++;
      renderQuestion();
    } else {
      showResults();
    }
  });

  document.getElementById('js-btn-back').addEventListener('click', function() {
    if (currentQ > 0) { currentQ--; renderQuestion(); }
    else { showScreen(screenIntro); }
  });

  function showResults() {
    var total = answers.reduce(function(sum, v) { return sum + (v || 0); }, 0);
    var profile = PROFILES.find(function(p) { return total >= p.min && total <= p.max; }) || PROFILES[1];

    document.getElementById('js-result-emoji').textContent = profile.emoji;
    document.getElementById('js-result-title').textContent = profile.title;
    document.getElementById('js-result-tagline').textContent = profile.tagline;
    document.getElementById('js-result-score').textContent = 'Score: ' + total + ' / 50';
    document.getElementById('js-result-desc').textContent = profile.desc;
    document.getElementById('js-result-insight').textContent = profile.insight;

    var resultMedia = document.getElementById('js-result-media');
    var resultImg = document.getElementById('js-result-img');
    if (resultMedia && resultImg) {
      var imgUrl = resultMedia.getAttribute('data-img-' + profile.key);
      if (imgUrl) {
        resultImg.src = imgUrl;
        resultImg.alt = profile.title;
        resultImg.hidden = false;
      } else {
        resultImg.hidden = true;
      }
    }

    var goodEl = document.getElementById('js-breeds-good');
    goodEl.innerHTML = '';
    profile.goodBreeds.forEach(function(b) {
      var li = document.createElement('li'); li.textContent = b; goodEl.appendChild(li);
    });
    var careEl = document.getElementById('js-breeds-care');
    careEl.innerHTML = '';
    profile.careBreeds.forEach(function(b) {
      var li = document.createElement('li'); li.textContent = b; careEl.appendChild(li);
    });

    showScreen(screenResult);
  }

  function escHtml(str) {
    return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  // Debug shortcut: open the page with ?preview=result to skip straight to the results screen
  if (new URLSearchParams(window.location.search).get('preview') === 'result') {
    answers = QUESTIONS.map(function() { return 3; });
    showResults();
  }
})();
